


import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import Filter from '@/library/filter/filter.interface';
import {FilterEqual} from '@/library/filter/filter-equal';
import AnalyticsService from '@/services/analytics.service';

@Component({})
export default class AppMapSearch extends Vue {

  @Prop({default: false})
  public disabled!: boolean;

  @Emit('search')
  public emitSearch(searchString: string): Filter {
    return new FilterEqual('search', searchString);
  }

  public searchString: string = '';
  private debounce: number = 0;
  private debounceLogToAnalytics: number = 0;
  private analyticsService: AnalyticsService = AnalyticsService.getInstance();

  constructor() {
    super();
  }

  public handleKeyup(event: KeyboardEvent): void {
    const keyCode: number = event.which || event.keyCode;
    keyCode === 13 ? this.closeKeyboard(event) : this.filter();
  }

  public clear(): void {
    this.searchString = '';
    setTimeout(() => {
      this.emitSearch(this.searchString);
    });
  }

  public focusInput(): void {
    (this.$refs.input as HTMLInputElement).focus();
  }

  private filter(): void {
    clearTimeout(this.debounce)
    this.debounce = setTimeout(() => {
      this.emitSearch(this.searchString);
      this.logToAnalytics();
    }, 750)
  }

  private closeKeyboard(event: KeyboardEvent): void {
    if (event.target) {
      event.preventDefault();
      (event.target as HTMLInputElement).blur();
    }
  }

  private logToAnalytics(): void {
    clearTimeout(this.debounceLogToAnalytics);
    this.debounceLogToAnalytics = setTimeout(() => {
      if (this.searchString !== '') {
        this.analyticsService.logMapSearchTerm(this.searchString.toLowerCase().trim());
      }
    }, 5000);
  }
}
